import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

interface Props {
  index: number;
  onRemoveOrderSubmissionContact?: (index: number) => void;
  readOnly?: boolean;
}

export const Header = ({
  index,
  onRemoveOrderSubmissionContact,
  readOnly,
}: Props) => {
  const { t } = useTranslation();
  const isFirst = index === 0;

  return (
    <Stack alignItems="center" direction="row" spacing={8}>
      <Typography variant="bodyBold">
        {t(
          isFirst
            ? 'client.client.orderSubmissionContacts.contactTitle'
            : 'client.client.orderSubmissionContacts.otherContactTitle'
        )}
      </Typography>
      {!readOnly && onRemoveOrderSubmissionContact && !isFirst && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemoveOrderSubmissionContact?.(index)}
        />
      )}
    </Stack>
  );
};
